import { render } from "./Screenshots.vue?vue&type=template&id=032b5a97&scoped=true"
import script from "./Screenshots.vue?vue&type=script&lang=js"
export * from "./Screenshots.vue?vue&type=script&lang=js"

import "./Screenshots.vue?vue&type=style&index=0&id=032b5a97&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032b5a97"]])

export default __exports__